/**
 * HeroUIColorsSection.tsx
 * HeroUI Colors section showing side-by-side light/dark comparison
 */

import React from 'react';
import { Card, CardHeader, CardBody } from '@enfomentis/ui';
import { Divider } from '@enfomentis/ui';
import { ColorCard } from '../components/ColorCard';

// HeroUI semantic colors for component testing
const heroUIColors = ['primary', 'secondary', 'success', 'warning', 'danger', 'default'] as const;

export const HeroUIColorsSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card shadow="lg" isHoverable>
        <CardHeader>
          <div className="space-y-2">
            <h3 className="text-xl font-semibold text-text-primary">HeroUI Component Colors</h3>
            <Divider />
            <p className="text-text-secondary">Test all HeroUI semantic colors with components in both light and dark themes</p>
          </div>
        </CardHeader>
        <CardBody>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-6xl mx-auto">
            
            {/* Light Theme */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-4 h-4 bg-white border border-gray-300 rounded"></div>
                <h4 className="font-semibold text-text-primary">Light Theme</h4>
              </div>
              <div className="space-y-4">
                {heroUIColors.map((color) => (
                  <ColorCard key={`light-${color}`} color={color} />
                ))}
              </div>
            </div>

            {/* Dark Theme */}
            <div className="dark space-y-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-4 h-4 bg-gray-800 border border-gray-600 rounded"></div>
                <h4 className="font-semibold text-text-primary">Dark Theme</h4>
              </div>
              <div className="space-y-4">
                {heroUIColors.map((color) => (
                  <ColorCard key={`dark-${color}`} color={color} />
                ))}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};